export const placeholderImages = {
  image: "/pkg_thumbnail_placeholder/image.svg",
  video: "/pkg_thumbnail_placeholder/video.svg",
  pdf: "/pkg_thumbnail_placeholder/pdf.svg",
  object: "/pkg_thumbnail_placeholder/object.svg",
  panorama: "/pkg_thumbnail_placeholder/panorama.svg",
};
